<template>
  <div class="transferLogsWrap">
    <div class="searchWrap">
      <el-input v-model="query.project_name" :placeholder="$tt('工程名称')" clearable />
      <el-input v-model="query.from_user_name" :placeholder="$tt('原用户')" clearable />
      <el-input v-model="query.to_user_name" :placeholder="$tt('接收用户')" clearable />
      <el-button type="primary" icon="el-icon-search" @click="search">{{ $tt("搜索") }}</el-button>
    </div>
    <el-table :data="tableDataInfo.result" border :max-height="listTableMaxHeight">
      <el-table-column prop="project_name" :label="$tt('工程名称')" />
      <el-table-column prop="from_user_name" :label="$tt('原用户')" />
      <el-table-column prop="to_user_name" :label="$tt('接收用户')" />
      <el-table-column prop="operator_name" :label="$tt('操作人')" />
      <el-table-column prop="operator_type" :label="$tt('操作人类型')" width="110">
        <template slot-scope="scope">{{ $tt(scope.row.operator_type) }}</template>
      </el-table-column>
      <el-table-column prop="create_time" :label="$tt('时间')" width="170">
        <template slot-scope="scope">{{ dateTransform(scope.row.create_time) }}</template>
      </el-table-column>
      <el-table-column :label="$tt('操作')" width="180">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.snapshot_project_id"
            type="text"
            @click="openSnapshot(scope.row)"
          >{{ $tt("查看存档") }}</el-button>
          <el-button
            v-if="!scope.row.project_deleted"
            type="text"
            @click="openReassign(scope.row)"
          >{{ $tt("改派") }}</el-button>
          <span v-else-if="!scope.row.snapshot_project_id">{{ $tt("工程已删除") }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-if="tableDataInfo.total > 8"
      :handleSizeChange="handleSizeChange"
      :handleCurrentPageChange="handleCurrentPageChange"
      :total="tableDataInfo.total"
    />
    <MoveDialog
      :visible="moveVisible"
      :switchDialogVisible="(v) => (moveVisible = v)"
      :refresh="afterMove"
      :projectIds="activeProjectIds"
    />
  </div>
</template>

<script>
import moment from "moment";
import Pagination from "@/components/Pagination";
import MoveDialog from "@/views/Projects/moveDialog.vue";

export default {
  listTableTopOffset: 268,
  components: { Pagination, MoveDialog },
  data() {
    return {
      query: {
        project_name: "",
        from_user_name: "",
        to_user_name: "",
      },
      tableDataInfo: {},
      moveVisible: false,
      activeProjectIds: [],
      reassignMode: false,
      reassignProjectId: "",
    };
  },
  mounted() {
    this.getTableData({});
  },
  methods: {
    dateTransform(d) {
      return d ? moment(d).format("YYYY-MM-DD HH:mm") : "";
    },
    handleSizeChange(page_size) {
      this.getTableData({ page_size, page_num: 1 });
    },
    handleCurrentPageChange(page_num) {
      this.getTableData({ page_num });
    },
    search() {
      this.getTableData({ page_num: 1 });
    },
    getTableData({ page_num = 1, page_size = 8 }) {
      this.$request
        .queryTransferLogs({
          page_num,
          page_size,
          ...this.query,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.tableDataInfo = res.data || {};
        });
    },
    openSnapshot(row) {
      this.$router.push({
        path: "/projects/projectsEdit",
        query: { id: row.snapshot_project_id, archive: "1" },
      });
    },
    openReassign(row) {
      this.reassignMode = true;
      this.reassignProjectId = row.project_id;
      this.activeProjectIds = [row.project_id];
      this.moveVisible = true;
    },
    afterMove() {
      this.moveVisible = false;
      this.getTableData({});
    },
  },
};
</script>

<style scoped lang="scss">
.transferLogsWrap {
  padding: 24px;
  background: #fff;
}
.searchWrap {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  .el-input {
    width: 200px;
  }
}
</style>
